// Alle teksten en gegevens staan hier zodat ze later makkelijk aan te passen zijn.

// Eigen foto's van De Proatkoele
const FOTO_FEEST = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/6dxg00ut_IMG_9617.jpeg";
const FOTO_BUFFET = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/7jyij2n7_IMG_9555.jpeg";
const FOTO_WESTERN = "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/53e69e856e38ef3388f79e1d4824a568091e337a6e40aa63d5dbaa2e89c865c0.jpeg";
const FOTO_HOLLAND = "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/9b2f5456eeade5bd0a78076fb8060f4e4bb622500cadc18614992b9f5f37d1ea.jpeg";
const FOTO_PUBQUIZ = "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/687991a18aae76c9854df576b56c708e09b8ad5826dff3b35997226eef5950f6.jpeg";
const FOTO_FEESTAVOND = "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/ead7d2bfecbc2e7f59ec5cc5e243ff129c1d45ebc4ea24c13d34f2230a4aceb6.jpeg";
const FOTO_KEUKEN = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/ujqw8k16_9a7ae51b-7140-4f44-a123-4c31dba5a0c4.jpeg";
const FOTO_DANIELLE = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/gu7u5c0z_IMG_7059.jpeg";
const FOTO_BAR = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/ap20j3no_IMG_7060.jpeg";
const FOTO_GEVEL = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/pziu482m_IMG_7061.jpeg";
const FOTO_KEUKEN_PREP = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/kx3ucyow_IMG_7062.jpeg";
const FOTO_KOUD_BUFFET = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/4vfz3xfa_IMG_7063.jpeg";
const FOTO_VISSCHOTEL = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/yl428uzo_IMG_7064.jpeg";
const FOTO_WARM_BUFFET = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/yxbzqiw6_IMG_7065.png";
const FOTO_LATIN = "https://customer-assets.emergentagent.com/job_proatkoele-feest/artifacts/ko2hw87n_IMG_7056.png";

export const bedrijf = {
  naam: "De Proatkoele",
  volledigeNaam: "Partycenter De Proatkoele",
  plaats: "Dedemsvaart",
  adres: "Tottenhamstraat 78",
  postcode: "7701 BP Dedemsvaart",
  telefoon: "0523 - 612 144",
  telefoonRaw: "+31523612144",
  mobiel: "06 - 11 47 47 47",
  mobielRaw: "+31611474747",
  email: "reserveren@deproatkoele.nl",
  facebook: "https://www.facebook.com/deproatkoele",
  instagram: "https://www.instagram.com/proatkoele/",
  mapsUrl: "https://www.google.com/maps/place/De+Proatkoele/data=!4m2!3m1!1s0x47c806a7ed5c97cb:0xc95799a381ca9bc6",
};

export const hero = {
  kop: "Een gezellige locatie voor feesten en arrangementen",
  ondertekst:
    "Iets te vieren of iets te organiseren? Bij De Proatkoele in Dedemsvaart ben je welkom. Een warme plek voor feesten, familiebijeenkomsten, groepen en bedrijfsuitjes.",
  afbeelding: FOTO_HOLLAND,
};

export const intro = {
  kop: "Welkom bij De Proatkoele",
  tekst: [
    "De Proatkoele is een sfeervol partycenter in Dedemsvaart. Een fijne plek om samen te komen, of het nu gaat om een verjaardag, een familiefeest, een borrel met vrienden of een bijeenkomst met je team.",
    "Je boekt bij ons een complete avond: zaal, sfeer, catering en eventueel entertainment in één. Daniëlle Krul regelt de locatie en organisatie, Johan Krul verzorgt de catering. Vertel ons wat je in gedachten hebt, dan kijken we samen wat past.",
  ],
};

export const sfeer = {
  bar: FOTO_BAR,
  gevel: FOTO_GEVEL,
  koudBuffet: FOTO_KOUD_BUFFET,
};

export const arrangementen = [
  {
    id: "basisfeest",
    titel: "Basisfeest",
    subtitel: "Voor verjaardagen, jubilea en familiefeesten",
    geschiktVoor: "Particulieren & families",
    omschrijving:
      "Onze standaard avond voor groepen die zelf de sfeer bepalen. Jullie brengen de muziek, wij zorgen voor de zaal, de bar en de catering. Gezellig, flexibel en compleet geregeld.",
    inbegrepen: [
      "Gebruik van de zaal met bar en dansvloer",
      "Aankleding op maat (in overleg)",
      "Hapjes en onbeperkt drinken",
    ],
    prijzen: [
      { label: "50 – 99 personen", pp: "€ 43,50" },
      { label: "100+ personen", pp: "€ 40,00" },
    ],
    prijsVanaf: "€ 43,50 p.p.",
    meta: "Vanaf 50 personen · 's avonds (in overleg)",
    afbeelding: FOTO_FEEST,
  },
  {
    id: "themafeest",
    titel: "Themafeest",
    subtitel: "Voor bedrijfsfeesten en grotere groepen",
    geschiktVoor: "Bedrijven & grote groepen",
    omschrijving:
      "Het themafeest voegt een volledige entertainmentlaag toe aan het basisfeest. Professionele organisaties als o.a. JP Activiteiten verzorgen het thema, de aankleding en de begeleiding; wij leveren de locatie en de catering. Daniëlle regelt de boeking, dus je hebt geen apart contact nodig.",
    themas: [
      "Western Night",
      "Oktoberfest",
      "Hollandse Avond",
      "Latin Night",
      "Disco Night",
      "Foute Party",
    ],
    prijzen: [
      { label: "80 – 119 personen", pp: "€ 68,45" },
      { label: "120+ personen", pp: "€ 64,95" },
    ],
    prijsVanaf: "€ 64,95 p.p.",
    meta: "Vanaf 80 personen · incl. entertainment · 's avonds",
    afbeelding: FOTO_WESTERN,
  },
  {
    id: "buffet",
    titel: "Buffetarrangement",
    subtitel: "Voor overdag en de vroege avond",
    geschiktVoor: "Groepen & bedrijven",
    omschrijving:
      "Voor bijeenkomsten overdag of vroeg in de avond: condoleances, bedrijfslunches, vergaderingen met diner of familiebijeenkomsten. Een koud voorgerecht, warm hoofdgerecht en nagerecht. Het arrangement is klaar om 20:00 uur.",
    inbegrepen: [
      "Koud buffet (voorgerecht)",
      "Warm buffet (hoofdgerecht)",
      "Nagerecht",
      "Gebruik van de zaal incl. familieruimte (op aanvraag)",
    ],
    prijzen: [
      { label: "Vanaf 30 personen", pp: "€ 69,50" },
    ],
    prijsVanaf: "€ 69,50 p.p. all-in",
    meta: "Vanaf 30 personen · aanvang 14:00 of 17:00, klaar om 20:00",
    afbeelding: FOTO_WARM_BUFFET,
  },
];

export const themaFeestThemas = [
  {
    naam: "Western Night",
    beschrijving: "Cowboys & country. Hoeden op, spellen erbij en een vleugje Wilde Westen.",
    afbeelding: FOTO_WESTERN,
  },
  {
    naam: "Oktoberfest",
    beschrijving: "Onze Proatkoele Fest: bier, blaasmuziek en lange tafels vol gezelligheid.",
    afbeelding: "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/5dc118f8f1183d1d2092d84a925966f47f08da89d287d839689de97bdac5445b.jpeg",
  },
  {
    naam: "Hollandse Avond",
    beschrijving: "Meezingers, Mokums en oer-Hollandse spellen. Oranje boven!",
    afbeelding: FOTO_HOLLAND,
  },
  {
    naam: "Latin Night",
    beschrijving: "Salsa, sangria en zwoele ritmes. Dansen tot de voetjes moe zijn.",
    afbeelding: FOTO_LATIN,
  },
  {
    naam: "Disco Night",
    beschrijving: "Glitter en glamour uit de 70's en 80's. Discobal aan, dansvloer open.",
    afbeelding: "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/126e7f7f56c9a9a07e54260ecbc8f287765d69e80ba9120cbfffadbf59c9d54e.jpeg",
  },
  {
    naam: "Foute Party",
    beschrijving: "Guilty pleasures en foute hits waar je stiekem dol op bent. Hossen maar!",
    afbeelding: "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/9f33ccd2df553e9d1940f95639ea2cf1ee922cc5bfde04bd385868f3002ce0a4.jpeg",
  },
  {
    naam: "WK Pubquiz",
    beschrijving: "Dé quiz voor voetballiefhebbers. Strijd in teams om de winst.",
    afbeelding: "https://static.prod-images.emergentagent.com/jobs/b1835d0e-1bc6-4023-90ef-07abc553c05b/images/9045d2362ce48c47a7f20eabd4aa058b89123be02fb936e373224d1c129b09cd.jpeg",
  },
];

export const combiAvond = {
  titel: "Eten én feesten op één avond",
  subtitel: "Maak er een complete avond van",
  tekst:
    "Begin vroeg op de avond met een verzorgd buffet en ga daarna over op een gezellig feest. De combinatie van samen eten en aansluitend feesten is een leuke optie voor bijvoorbeeld familie- en bedrijfsfeesten.",
  stappen: [
    {
      tijd: "Vroege avond",
      titel: "Eerst het buffet",
      tekst: "Rustig samen aan tafel met een koud en warm buffet en een nagerecht.",
    },
    {
      tijd: "Daarna",
      titel: "En dan feesten",
      tekst: "In onze danszaal met bar en dansvloer gaan we verder met de muziek.",
    },
  ],
  noot: "We bespreken graag de tijden en de invulling die bij jullie groep passen.",
};

export const voorwaarden = [
  "Boekingen lopen via Daniëlle Krul: 06 - 11 47 47 47 of via dit contactformulier.",
  "Na je aanvraag ontvang je een offerte van Daniëlle; na akkoord is de reservering definitief. Betaling verloopt via facturering.",
  "Annulering binnen 4 weken voor de datum: 100% van het afgesproken bedrag.",
  "Alle arrangementen zijn 18+.",
  "Prijzen zijn inclusief btw, exclusief extra's zoals luxe drankupgrades of een uitgebreid dessertbuffet.",
];

export const mogelijkheden = [
  { titel: "Verjaardagen", tekst: "Klein of groot, we maken er een gezellige dag van." },
  { titel: "Familiefeesten", tekst: "Jubilea, reünies en familiebijeenkomsten." },
  { titel: "Bedrijfsfeestjes", tekst: "Een ontspannen avond of themafeest met collega's." },
  { titel: "Groepsuitjes", tekst: "Gezellig samen met vrienden of een vereniging." },
  { titel: "Vergaderen met eten", tekst: "Vergaderen met aansluitend een buffet of activiteit." },
  { titel: "Themafeesten", tekst: "Van Oktoberfest tot Foute Party — kies je thema." },
];

export const waarom = [
  { titel: "Persoonlijke aanpak", tekst: "Daniëlle en Johan denken graag met je mee." },
  { titel: "Gezellige sfeer", tekst: "Een toegankelijke, warme plek waar je je thuis voelt." },
  { titel: "Geschikt voor groepen", tekst: "Van een kleine groep tot 120 personen." },
  { titel: "Alles in één", tekst: "Zaal, bar, catering en entertainment compleet verzorgd." },
  { titel: "Lokaal in Dedemsvaart", tekst: "Een vertrouwde locatie in de buurt, makkelijk te bereiken." },
];

export const galerij = [
  { url: FOTO_FEEST, alt: "Feest in De Proatkoele — cheers to 70 years" },
  { url: FOTO_HOLLAND, alt: "Hollandse Avond in de volle zaal" },
  { url: FOTO_WESTERN, alt: "Western Night met cowboyspellen" },
  { url: FOTO_BUFFET, alt: "Spit met varken bij De Proatkoele" },
  { url: FOTO_PUBQUIZ, alt: "WK Pubquiz avond" },
  { url: FOTO_FEESTAVOND, alt: "Feestavond met proostende gasten" },
  { url: FOTO_KEUKEN, alt: "Johan vers aan het werk in de keuken" },
  { url: FOTO_DANIELLE, alt: "Daniëlle bij een sfeervol gedekte buitentafel" },
  { url: FOTO_BAR, alt: "Achter de bar: vers getapt en met een glimlach" },
  { url: FOTO_GEVEL, alt: "Het gevelbord van De Proatkoele" },
  { url: FOTO_KEUKEN_PREP, alt: "Vers bereid in eigen keuken" },
  { url: FOTO_KOUD_BUFFET, alt: "Feestelijk opgemaakt koud buffet" },
  { url: FOTO_VISSCHOTEL, alt: "Visschotel met langoustines en zalm" },
];

export const praktisch = {
  intro: "Goed om te weten voordat je langskomt of een aanvraag doet.",
  punten: [
    { titel: "Locatie", tekst: "Tottenhamstraat 78, Dedemsvaart. Centraal en goed bereikbaar." },
    { titel: "Parkeren", tekst: "Ruime parkeergelegenheid in de buurt van de locatie." },
    { titel: "Op afspraak", tekst: "Een feest of bijeenkomst plannen we graag samen op afspraak." },
  ],
};
